const INITIAL_STATE = {
  validateCouponCode: false,
  errors: {},
}
    
const validateCouponCode = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'VALIDATE_COUPON_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, validateCouponCode: action.data }
  case 'VALIDATE_COUPON_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default validateCouponCode;